import { makeStyles } from '@mui/styles';
import { appBarZIndex } from '../../../theme/z-index';
import { ReactNode } from 'react';

const useAppBarStyles = makeStyles((theme) => ({
  root: {
    position: 'fixed',
    top: 0,
    width: '100%',
    height: '80px',
    zIndex: appBarZIndex(theme)
  }
}));

export function AppBar({ children }: { children: ReactNode }) {
  const classes = useAppBarStyles();
  return <div className={classes.root}>{children}</div>;
}
